<!--suppress ALL -->
<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                  <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                  <el-breadcrumb-item>{{$t('menu.pro_active')}}</el-breadcrumb-item>
                                  <el-breadcrumb-item>{{$t('submenu.jamoatchilik_kengashi')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
        </div>
        <section class="section py-3">
            <div class="container">
              <div class="tab_div_top" style="margin-bottom: 150px;">
                <el-row :gutter="15">
                  <el-col :sm="24" :md="12" :lg="8" class="mb-2 mb-lg-10">
                    <div class="card card-lift shadow border-1 card_xalqaro">
                      <router-link to="/hayat" style="color: #002060;">
                        <img src="img/strategy/x_paper.svg" class="image_xalqaro">
                        <div class="vertical-center" style="margin-left: 85px;">
                          <strong class="card_span_muvofiq">{{$t('muvofiq.muvofiq_title')}}</strong>
                        </div>
                      </router-link>
                    </div>
                  </el-col>
                  <el-col :sm="24" :md="12" :lg="8" class="mb-2 mb-lg-10">
                    <div class="card card-lift shadow border-1 card_xalqaro">
                      <router-link to="/kengash" style="color: #002060;">
                        <img src="img/strategy/x_paper.svg" class="image_xalqaro">
                        <div class="vertical-center" style="margin-left: 85px;">
                          <strong class="card_span_muvofiq">{{$t('muvofiq.muvofiq_title2')}}</strong>
                        </div>
                      </router-link>
                    </div>
                  </el-col>
                  <el-col :sm="24" :md="12" :lg="8" class="mb-2 mb-lg-10">
                    <div class="card card-lift shadow border-1 card_xalqaro">
                      <router-link to="/attestatsiya_komissiyasi" style="color: #002060;">
                        <img src="img/strategy/x_paper.svg" class="image_xalqaro">
                        <div class="vertical-center" style="margin-left: 85px;">
                          <strong class="card_span_muvofiq">{{$t('muvofiq.muvofiq_title3')}}</strong>
                        </div>
                      </router-link>
                    </div>
                  </el-col>
                  <el-col :sm="24" :md="12" :lg="8" class="mb-2 mb-lg-10">
                    <div class="card card-lift shadow border-1 card_xalqaro">
                      <router-link to="/komissiyasi" style="color: #002060;">
                        <img src="img/strategy/x_paper.svg" class="image_xalqaro">
                        <div class="vertical-center" style="margin-left: 85px;">
                          <strong class="card_span_muvofiq">{{$t('muvofiq.muvofiq_title4')}}</strong>
                        </div>
                      </router-link>
                    </div>
                  </el-col>
                  <el-col :sm="24" :md="12" :lg="8" class="mb-2 mb-lg-10">
                    <div class="card card-lift shadow border-1 card_xalqaro">
                      <router-link to="/xarid_komissiyasi" style="color: #002060;">
                        <img src="img/strategy/x_paper.svg" class="image_xalqaro">
                        <div class="vertical-center" style="margin-left: 85px;">
                          <strong class="card_span_muvofiq">{{$t('muvofiq.muvofiq_title5')}}</strong>
                        </div>
                      </router-link>
                    </div>
                  </el-col>
                  <el-col :sm="24" :md="12" :lg="8" class="mb-2 mb-lg-10">
                    <div class="card card-lift shadow border-1 card_xalqaro">
                      <router-link to="/jamoatchilikkengashi" style="color: #002060;">
                        <img src="img/strategy/x_paper.svg" class="image_xalqaro">
                        <div class="vertical-center" style="margin-left: 85px;">
                          <strong class="card_span_muvofiq">{{$t('muvofiq.muvofiq_title6')}}</strong>
                        </div>
                      </router-link>
                    </div>
                  </el-col>
                </el-row>
              </div>

            </div>
        </section>

    </div>
</template>

<script>
    import moment from "moment";
    export default {
        data() {
            return {
                activeName: 'davlat_dasturi',
                pagination: {
                    default: 12
                },
                categories: [],
                categoryId: 12,
                news: [],
                paging: {
                    sort: null,
                    page: 0,
                    size: 12,
                    total: 0,
                    current: 1
                }
            }
        },
        methods: {
            handleClick(tab, event) {
                this.paging.current = 1;
            },
            parseDate(dateTime) {
                return moment(dateTime).format("DD.MM.YYYY");
            },
            onPageChange(current) {
                this.paging.current = current;
                this.paging.page = current - 1;
                this.loadNewsByCategory();
            }
        },
        created() {
            this.loadNewsByCategory();
        }
    };
</script>
<style scoped>
    .bg-defaultnew {
        background: #fff;
        cursor: pointer;
    }

    .press_news_status {
        color: #fff;
        position: absolute;
        font-size: 12px;
        text-transform: uppercase;
        padding: 4px 8px;
        right: 10px;
        top: 10px;
        border-radius: 0px;
        background: rgba(57, 72, 105, 0.85);
    }

    .press_fastnews_status {
        color: #fff;
        position: absolute;
        font-size: 12px;
        text-transform: uppercase;
        padding: 4px 8px;
        right: 10px;
        top: 10px;
        border-radius: 0px;
        background: rgba(207, 52, 118, 0.85);
    }

    .tab_div_top {
        min-height: 400px;
        margin-top: 15px;
    }

    /deep/ .card .card-blockquote {
        padding: 1rem;
        position: relative;
        padding-top: 5px;
        height: 88px;
    }

    /deep/ .badge {
        display: inline-block;
        padding: 0.35rem 0.375rem;
        font-size: 76%;
        font-weight: 600;
        margin-left: -6px;
        line-height: 1;
        text-align: center;
        position: absolute;
        white-space: nowrap;
        top: -32px;
        vertical-align: baseline;
        border-radius: 0rem;
    }

    /deep/ .badge-primary {
        color: #394869;
        background-color: #f0f4f9;
    }

    /deep/ .card .card-blockquote {
        padding: 1rem;
        position: relative;
        padding-top: 5px;
        height: 38px;
    }

    /deep/ .card-img-top {
        height: 240px;
        object-fit: cover;
        border-radius: 0px;
    }

    .textnew-title_color {
        color: #394869;
    }
    .pdf_link {
      display: block;
      text-align: right;
      margin-top: -7px;
    }
</style>
